export const transformLabels = (result) => {
  return result.map((label) => ({
    id: Number(label.id),
    value: Number(label.id),
    label: label.value,
    textColor: label.textColor,
    backgroundColor: label.backgroundColor,
  }));
};
